export var LiveStreamingStates = /*#__PURE__*/function (LiveStreamingStates) {
  LiveStreamingStates["WAS_LIVE"] = "was-livestreaming";
  LiveStreamingStates["IS_LIVE"] = "livestreaming";
  LiveStreamingStates["PLANNED"] = "planned";
  LiveStreamingStates["UNKNOWN"] = "unknown";
  return LiveStreamingStates;
}({});